import { z } from 'zod'
import { deviceSchema } from '../devices'

export const deviceGroupDevicesSchema = z.object({
  devices: z.array(deviceSchema),
})

export type TDeviceGroupDevices = z.infer<typeof deviceGroupDevicesSchema>
